import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, type Breakpoint } from '@mui/material/styles';

type BreakpointOrNull = Breakpoint | null;
/**
 * @returns The highest breakpoint value on the current view.
 */
const useBreakpointWidth = () => {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
        keys.reduce((output: BreakpointOrNull, key: Breakpoint) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const matches = useMediaQuery(theme.breakpoints.up(key));
            return !output && matches ? key : output;
        }, null) || 'xs'
    );
};

export default useBreakpointWidth;